import { useEffect, useRef } from "react";
import { Knopf } from "../../kern/ui/Knopf";
import s from "../../kern/ui/ui.module.css";

/** „3 Unteraufgaben sind noch offen. Mit erledigen?“ (KONZEPT.md, Unteraufgaben) */
export function Rueckfrage({ text, onAntwort, onAbbrechen }: { text: string | null; onAntwort: (mit: boolean) => void; onAbbrechen: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (text && !d.open) d.showModal();
    if (!text && d.open) d.close();
  }, [text]);
  return (
    <dialog ref={ref} className={s.dialog} aria-labelledby="rueckfrage-titel" onCancel={(e) => { e.preventDefault(); onAbbrechen(); }}>
      <h2 id="rueckfrage-titel">{text}</h2>
      <p>Die Hauptaufgabe wird erledigt. Was passiert mit den offenen Unteraufgaben?</p>
      <div className={s.dialogKnoepfe}>
        <Knopf onClick={onAbbrechen}>Abbrechen</Knopf>
        <Knopf onClick={() => onAntwort(false)}>Offen lassen</Knopf>
        <Knopf art="primaer" ohnePunkt onClick={() => onAntwort(true)}>
          Ja, alle erledigen
        </Knopf>
      </div>
    </dialog>
  );
}
